import type { HistoryEntry } from "../../../api/types";
import { fmtDate } from "../../../utils/labels";

const ACTION_LABEL: Record<string, string> = {
  SHIFT_CREATED: "Created",
  SHIFT_UPDATED: "Edited",
  SHIFT_CONFIRMED: "Confirmed",
  SHIFT_CANCELLED: "Cancelled",
  FLAG_RAISED: "Flag raised",
  FLAG_ACKNOWLEDGED: "Flag acknowledged",
  FLAG_RESOLVED: "Flag resolved",
  SHIFT_TIMES_RECOMPUTED: "Times recomputed",
};
const DOT: Record<string, string> = { FLAG_RAISED: "bg-signal", SHIFT_CANCELLED: "bg-zinc-500", SHIFT_CONFIRMED: "bg-emerald-400", FLAG_RESOLVED: "bg-emerald-400" };
const HIDDEN = new Set(["start_at_utc", "end_at_utc", "attention_flag"]);

const show = (v: unknown) => (v === null || v === undefined || v === "" ? "—" : String(v));

export function ShiftHistory({ items }: { items: HistoryEntry[] }) {
  if (!items.length) return <p className="text-sm text-zinc-500">No history yet.</p>;
  return (
    <ol data-testid="shift-history" className="relative space-y-5 border-l border-white/10 pl-5">
      {items.map((h) => {
        const changes = Object.entries(h.changes ?? {}).filter(([k]) => !HIDDEN.has(k));
        return (
          <li key={h.id} data-testid={`history-entry-${h.action.toLowerCase()}`} className="relative">
            <span className={`absolute -left-[25px] top-1.5 h-2 w-2 rounded-full ${DOT[h.action] ?? "bg-white"}`} />
            <p className="text-sm text-white">
              <span className="font-semibold">{ACTION_LABEL[h.action] ?? h.action}</span>
              <span className="text-zinc-500"> · {h.actor_name ?? h.actor_type} · {fmtDate(h.occurred_at)}</span>
            </p>
            {h.detail && <p className="mt-1 text-xs text-zinc-400">{h.detail}</p>}
            {h.action !== "SHIFT_CREATED" && changes.length > 0 && (
              <ul className="mt-1 space-y-0.5 font-mono text-[11px] text-zinc-400">
                {changes.map(([k, v]) => (
                  <li key={k}><span className="text-zinc-500">{k}</span>: {show(v.from)} → <span className="text-zinc-200">{show(v.to)}</span></li>
                ))}
              </ul>
            )}
          </li>
        );
      })}
    </ol>
  );
}
